import api from './axiosConfig';

// Servicios de autenticación
export const authService = {
  // Login - ruta correcta: /login
  login: async (email, password) => {
    try {
      const response = await api.post('/login', { email, password });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Verificar autenticación - ruta correcta: /auth
  checkAuth: async () => {
    try {
      const response = await api.get('/auth');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};

export default authService;
